module.exports = __webpack_public_path__ + "media/checkmarks/checkmark-cd926c86.svg";